"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = exports.handleTriggerModal = exports.toggleBlockBodySimple = exports.variants = exports.createModalParent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_dom_1 = __importDefault(require("react-dom"));
var react_redux_1 = require("react-redux");
var react_redux_2 = require("react-redux");
var react_1 = require("react");
var styles_1 = require("../../styles");
// temp
// @ts-ignore
var triggerModal = function (modalObject) {
    return {
        type: 'MODAL/TRIGGER',
        payload: modalObject
    };
};
var Components_1 = require("./Components");
var createModalParent = function (id) {
    if (id === void 0) { id = 'root-modals'; }
    if (typeof window === 'undefined')
        return null;
    var firstScriptElement = document.body.querySelector('script');
    var parentElement = document.getElementById(id);
    if (!parentElement) {
        parentElement = document.createElement('div');
        parentElement.id = id;
        parentElement.style.cssText = "\n      z-index: 9999;\n      position: relative;\n      top: 0;\n      display: fixed;\n      left: 0;\n    ";
        document.body.insertBefore(parentElement, firstScriptElement);
    }
    return parentElement;
};
exports.createModalParent = createModalParent;
exports.variants = {
    active: {
        display: 'flex',
        opacity: 1,
        transition: __assign({}, (0, styles_1.getTransition)())
    },
    inactive: {
        opacity: 0,
        transitionEnd: {
            display: 'none',
        },
        transition: __assign(__assign({}, (0, styles_1.getTransition)()), { when: 'afterChildren' })
    }
};
var toggleBlockBodySimple = function (isActive) {
    isActive && (document === null || document === void 0 ? void 0 : document.body) ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'initial';
};
exports.toggleBlockBodySimple = toggleBlockBodySimple;
var handleTriggerModal = function (dispatch, _a) {
    var id = _a.id, isActive = _a.isActive, payload = _a.payload;
    return function () {
        var _a;
        return dispatch(triggerModal((_a = {}, _a[id] = { isActive: isActive, payload: payload }, _a)));
    };
};
exports.handleTriggerModal = handleTriggerModal;
var useModal = function (id, overlay, lockScroll) {
    if (overlay === void 0) { overlay = true; }
    if (lockScroll === void 0) { lockScroll = true; }
    var modalParentElement = (0, react_1.useRef)((0, exports.createModalParent)());
    var dispatch = (0, react_redux_1.useDispatch)();
    // @ts-ignore
    var _a = (0, react_redux_2.useSelector)(function (_a) {
        var modals = _a.modals;
        return modals[id] ? modals[id] : {};
    }, react_redux_2.shallowEqual), isActive = _a.isActive, payload = _a.payload;
    var triggerModal = (0, react_1.useCallback)(function (isActive, payload) {
        if (payload === void 0) { payload = null; }
        return function () {
            lockScroll && (0, exports.toggleBlockBodySimple)(isActive);
            (0, exports.handleTriggerModal)(dispatch, { id: id, isActive: isActive, payload: payload })();
        };
    }, []);
    var render = (0, react_1.useCallback)(function (Component) { return (modalParentElement.current ? react_dom_1.default.createPortal((0, jsx_runtime_1.jsxs)(Components_1.Aside, __assign({ animate: isActive ? 'active' : 'inactive', variants: exports.variants }, { children: [overlay ? (0, jsx_runtime_1.jsx)(Components_1.Overlay, { onClick: triggerModal(false), className: isActive ? 'overlay active' : 'overlay' }) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), Component] }), id), modalParentElement.current) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})); }, [modalParentElement.current, isActive]);
    (0, react_1.useEffect)(function () {
        if (typeof isActive === 'undefined') {
            triggerModal(false)();
        }
    }, []);
    return { render: render, open: triggerModal(true), close: triggerModal(false), isActive: isActive, payload: payload, triggerModal: triggerModal };
};
exports.useModal = useModal;
